import Const from 'constants';

const AllowOnlyOneKPositionPerLineup = {
    setAllowOnlyOneKPositionPerLineupFromStorage(value) {
        return (dispatch) => {
            dispatch(this.setAllowOnlyOneKPositionPerLineup(value, {saveToStorage: false}));
        };
    },

    setAllowOnlyOneKPositionPerLineup(value, options = {}) {
        return (dispatch) => {
            const {saveToStorage = true} = options;

            dispatch({
                type: Const.SET_ALLOW_ONLY_ONE_K_POSITION_PER_LINEUP,
                allowOnlyOneKPositionPerLineup: Boolean(value),
            });

            saveToStorage && dispatch(
                this.saveDataToStorage('allowOnlyOneKPositionPerLineup', function (state) {
                    const {filters} = state.lineupsData;

                    return filters.allowOnlyOneKPositionPerLineup;
                }),
            );
        };
    },
};

export default AllowOnlyOneKPositionPerLineup;
